import { Department } from 'components/careers/types';

// Careers page does not need translations
const getDepartmentLabel = (department: Department, count?: number): string => {
  return count != null ? `${department} (${count})` : (department as string);
};

export default getDepartmentLabel;
